import { render, staticRenderFns } from "./BadgeAlertComponent.vue?vue&type=template&id=68422708&"
import script from "./BadgeAlertComponent.vue?vue&type=script&lang=js&"
export * from "./BadgeAlertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports